import { useEffect } from 'react';

/**
 * ScrollEffects — componente global que ativa automaticamente
 * os efeitos de scroll em todos os elementos com classes reveal-*
 * Basta incluir <ScrollEffects /> uma vez no App.
 */
const ScrollEffects = () => {
  useEffect(() => {
    const CLASSES = [
      'reveal-up', 'reveal-left', 'reveal-right', 'reveal-scale',
      'reveal-blur', 'reveal-clip', 'reveal-split-left', 'reveal-split-right',
      'reveal-zoom', 'reveal-rotate', 'reveal-flip', 'reveal-words',
      'section-glow', 'border-draw', 'line-reveal', 'progress-bar-animate',
    ];

    const selector = CLASSES.map(c => `.${c}`).join(', ');

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    // Observe existing elements
    const elements = document.querySelectorAll(selector);
    elements.forEach((el) => observer.observe(el));

    // Also watch for dynamically added elements via MutationObserver
    const mutation = new MutationObserver(() => {
      const newEls = document.querySelectorAll(selector);
      newEls.forEach((el) => {
        if (!el.dataset.observed) {
          el.dataset.observed = '1';
          observer.observe(el);
        }
      });
    });

    mutation.observe(document.body, { childList: true, subtree: true });

    return () => {
      observer.disconnect();
      mutation.disconnect();
    };
  }, []);

  return null;
};

export default ScrollEffects;
